import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiCalendar, FiDownload, FiBell, FiChevronDown } from 'react-icons/fi';
import { LuActivity } from 'react-icons/lu'; // Clean pulse/live waveform icon

const SensorDetailsHeader = () => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [startDate, setStartDate] = useState('2026-05-26');
  const [endDate, setEndDate] = useState('2026-06-01');

  // Hardcoded count matching the badge in the image
  const alertCount = 3;

  return (
    <header className="w-full bg-[#FAF9F6] p-6 font-sans select-none flex flex-col xl:flex-row xl:items-center xl:justify-between gap-6">
      
      {/* Left section: Navigation back link and title banner */}
      <div className="space-y-2.5">
        {/* Back navigation matching image text */}
        <Link 
          to="/categories/all" 
          className="inline-flex items-center gap-2 text-[13px] font-bold text-[#0052FF] hover:opacity-80 transition-opacity"
        >
          <FiArrowLeft className="w-3.5 h-3.5 stroke-[2.5]" />
          <span>Back to Stage 2 – Sensor List</span>
        </Link>
        
        {/* Title row with badge and status label */}
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="text-[22px] font-extrabold text-gray-900 tracking-tight">
            Stage 3 – Sensor Details – Live (Today)
          </h1>
          
          {/* Green LIVE Pill */}
          <span className="bg-[#10B981] text-white text-[10px] font-extrabold px-1.5 py-0.5 rounded-md tracking-wider">
            LIVE
          </span>
          
          {/* Muted subtitle help text */}
          <span className="text-[13px] font-medium text-gray-400">
            Real-time data
          </span>
        </div>
      </div>

      {/* Right section: Control menu row buttons */}
      <div className="flex flex-wrap items-center gap-3 shrink-0">
        
        {/* Blue Accent Live Filter Button */}
        <button className="flex items-center gap-2 bg-[#F5F8FF] border border-[#DBE5FF] p-2.5 px-4 rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.01)] text-[#0052FF]">
          <LuActivity className="w-4 h-4 stroke-[2.2]" />
          <span className="text-[13px] font-bold tracking-tight">
            Live (Today)
          </span>
        </button>

        {/* Custom Range Selector Dropdown */}
        <div className="relative">
          <button 
            onClick={() => setIsCalendarOpen(!isCalendarOpen)}
            className="flex items-center gap-2 bg-white border border-gray-200 hover:border-gray-300 p-2.5 px-4 rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.01)] text-gray-700 transition-colors cursor-pointer"
          >
            <FiCalendar className="w-4 h-4 text-gray-600 stroke-[2]" />
            <span className="text-[13px] font-bold tracking-tight text-gray-700">
              Custom Range
            </span>
            <FiChevronDown className={`w-3.5 h-3.5 text-gray-400 transition-transform ${isCalendarOpen ? 'rotate-180' : ''}`} />
          </button>

          {/* Simple Dropdown Picker Panel */}
          {isCalendarOpen && (
            <div className="absolute right-0 mt-2 bg-white border border-gray-100 rounded-xl shadow-xl z-50 p-4 w-64">
              <div className="space-y-3">
                <div>
                  <label className="text-[10px] font-bold text-gray-400 block mb-1">START DATE</label>
                  <input 
                    type="date" 
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="w-full border border-gray-200 rounded-lg p-1.5 text-xs font-semibold text-gray-800"
                  />
                </div>
                <div>
                  <label className="text-[10px] font-bold text-gray-400 block mb-1">END DATE</label>
                  <input 
                    type="date" 
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="w-full border border-gray-200 rounded-lg p-1.5 text-xs font-semibold text-gray-800"
                  />
                </div>
                <button 
                  onClick={() => setIsCalendarOpen(false)}
                  className="w-full py-1.5 bg-[#0052FF] text-white font-bold text-xs rounded-lg shadow-sm"
                >
                  Apply Filter
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Export Action Button */}
        <button className="flex items-center gap-2 bg-white border border-gray-200 hover:border-gray-300 p-2.5 px-4 rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.01)] transition-colors cursor-pointer">
          <FiDownload className="w-4 h-4 text-[#0052FF] stroke-[2.2]" />
          <span className="text-[13px] font-bold text-[#0052FF] tracking-tight">
            Export
          </span>
        </button>

        {/* Notification Bell Badge Button */}
        <button className="relative bg-white border border-gray-200 hover:border-gray-300 w-11 h-11 rounded-xl flex items-center justify-center shadow-[0_1px_3px_rgba(0,0,0,0.01)] transition-colors text-gray-700 cursor-pointer">
          <FiBell className="w-4.5 h-4.5 stroke-[2]" />
          {/* Notification Counter Dot matching the image style exactly */}
          <span className="absolute -top-1.5 -right-1.5 bg-[#EF4444] text-white text-[10px] font-black w-5 h-5 rounded-full flex items-center justify-center border-2 border-white shadow-xs">
            {alertCount}
          </span>
        </button>

      </div>

    </header>
  );
};

export default SensorDetailsHeader;
